<template>
  <div class="Wdgt-Content-Comments" :class="get_modifyClass">
    <p class="Wdgt-Content-Comments__ttl">
      Комментарии <span class="Wdgt-Content-Comments__comments-count" v-if="get_isReady">{{ get_data.comments_count }}</span>
    </p>
    <div class="Wdgt-Content-Comments__form" ref="contentComments">
      <CommentsForm :commentsPlace="props.commentsPlace" :mode="'default'" :postId="get_postId" :context="context"/>
    </div>
    <CommentsListContent class="Wdgt-Content-Comments__list" :postId="get_postId" :context="context" :commentsPlace="props.commentsPlace" />
  </div>
</template>

<script setup>
  import { computed, ref, onBeforeMount } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  //----------------------------
  import CommentsForm from '@entities/Comments/CommentsForm/CommentsForm.vue';
  import CommentsListContent from '@entities/Comments/CommentsList/CommentsListContent.vue';
  //----------------------------
  const store = useStore();
  const props = defineProps(Props());
  //----------------------------
  const data = ref(null);
  const context = ref(null);
  //----------------------------
  onBeforeMount(() => {
    if (props.postId) {
      context.value = 'infonoise';
      data.value = store.state.ContentSystem.Alpha.list[props.postId] || store.state.ContentSystem.Infonoise.list[props.postId];
    } else if (props.signalId) {
      context.value = 'signal';
      data.value = store.state.OldSignals.data[props.signalId];
    }
  })
  //----------------------------
  //Определить объект, откуда брать данные
  const get_data = computed(() => {
    if(props.postId){
      return store.state.ContentSystem.Alpha.list[props.postId] || store.state.ContentSystem.Infonoise.list[props.postId];
    }else if(props.signalId){
      return store.state.OldSignals.data[props.signalId];
    }
  })
  //Получить контекст объекта для комментариев
  const get_commentsCtx = computed(() => {
    if(props.commentsPlace === 'popup') return 'popupComments';
    else if(props.commentsPlace === 'page') return 'contentPageComments';
  });
  //Получить id поста
  const get_postId = computed(() => {
    const id = props.postId ?? props.signalId;
    return id !== undefined ? parseInt(id) || 0 : 0;
  });
  //Готовы ли комментарии к выдаче?
  const get_isReady = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].isReady);
  //Класс модификатор
  const get_modifyClass = computed(() => get_isReady.value ? '' : 'Wdgt-Content-Comments--height');
  //-----------------------------
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>